import { useBetslipContext } from '@cx-web/feature-betslip/context';
import { useServicesContext } from '@cx-web/feature-services';

import styles from '../style/bookie-selector-2.module.css';

import BookieSelection from './bookie-selection';

const BookieSelector = () => {
  const { labelActions } = useServicesContext();
  const { bookieOdds, selectedBookie } = useBetslipContext();

  const renderBookieSelections = () => {
    const bookiesWithIndex = bookieOdds
      .map((bookie, index) => ({ ...bookie, index }))
      .filter(bookie => bookie.bookmakerCode !== selectedBookie?.bookmakerCode);

    const traditionalBookies = bookiesWithIndex.filter(bookie => bookie.bookmakerType === 'traditional');
    const exchangeBookies = bookiesWithIndex.filter(bookie => bookie.bookmakerType === 'exchange');

    return [...traditionalBookies, ...exchangeBookies].map(bookie => (
      <BookieSelection key={`$bookie_selection_${bookie.bookmakerCode}`} selectedBookie={bookie} />
    ));
  };

  return (
    <div className={styles.otherBookieWrapper} data-testid="bookie-selector">
      <div className={styles.otherBookies}>{labelActions.get('OTHER_BOOKIES')}:</div>
      {renderBookieSelections()}
    </div>
  );
};

export default BookieSelector;
